import React from 'react'
import {GROUPLEADERCRED} from '../actionTypes';

const initialState = {
  username: "",
  password: "",
};
export const GroupLeaderLogin = (state = initialState, action)=>{
     switch (action.type) {
       case GROUPLEADERCRED :
        // localStorage.setItem('tabValue', action.username);
        return {
        username: action.username,
        password: action.password
      };
    default:
      return state;
  }
}

